import React from "react";
import { Localize } from "components/service";
import StaffManagementFields from "../fields";


const hiddenGroupCell = () => null;
const hiddenGroupCellProps = () => ({ colSpan: 0 });

const StaffAttendanceTableHelper = (groupBy = "date", onOpenLocation) => {
    const columns = [
        {
            title: <Localize>STAFF_MANAGEMENT.Column_Worker</Localize>,
            dataIndex: "group",
            width: 267,
            render: (content) => content,
            onCell: () => ({ colSpan: 6 }),
        },
        {
            title: groupBy === "subcontractor" ?
                <Localize>STAFF_MANAGEMENT.Column_Date</Localize> :
                <Localize>STAFF_MANAGEMENT.Column_Subcontractor</Localize>,
            dataIndex: "context",
            width: 310,
            render: hiddenGroupCell,
            onCell: hiddenGroupCellProps,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_FirstCheckIn</Localize>,
            dataIndex: "firstCheckIn",
            width: 225,
            render: hiddenGroupCell,
            onCell: hiddenGroupCellProps,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_LastCheckOut</Localize>,
            dataIndex: "lastCheckOut",
            width: 230,
            render: hiddenGroupCell,
            onCell: hiddenGroupCellProps,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_TotalHours</Localize>,
            dataIndex: "totalHours",
            width: 250,
            render: hiddenGroupCell,
            onCell: hiddenGroupCellProps,
        },
        {
            dataIndex: "details",
            width: 39,
            render: hiddenGroupCell,
            onCell: hiddenGroupCellProps,
        },
    ];

    const data = (groups = []) => groups.map((group) => ({
        key: group.id,
        group: (
            <StaffManagementFields.AttendanceGroup
                group={ group }
                groupBy={ groupBy }
                onOpenLocation={ onOpenLocation } />
        ),
    }));

    return { columns, data };
};

export default StaffAttendanceTableHelper;
